import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader"
import { useNavigate } from "react-router-dom";
import BanqueService from "../../services/Banque";
import { TextField } from "@material-ui/core";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ExtraitTable from "./ExtraitTable";




const ExtraitBankAccount=({startLoading,stopLoading})=>{
const [banqueAccountInfo, setBanqueAccountInfo] = useState();
  const [listTransaction, setListTransaction] = useState([]);
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [typeValidationPayement, setTypeValidationPayement] = useState("none");
    const [data, setData] = useState(null);

  const [ss, setSs] = useState();
  const [sortie, setSortie] = useState(null);
  const [entree, setEntre] = useState(null);


  const [tt, setTt] = useState();
  const [se, setSe] = useState();


 const navigate = useNavigate();
  useEffect(() => {
    startLoading();
    BanqueService.getBankAccountInfo(sessionStorage.getItem("idBankAccount"))
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          setBanqueAccountInfo(response.data.success);
        }
      })
      .catch(() => {
        console.log("error");
      })
      .finally(() => {
        stopLoading();
      });
  
  }, []);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };
    const onChangeDateBegin = (event) => {
    const date = new Date(event.target.value); // Parse the input date
    date.setHours(0, 0, 0, 0); // Set time to 00:00:00
    const formattedDate = formatDate(date); // Format the date
    setDateBegin(formattedDate);
    console.log(formattedDate)
  };

  const onChangeDateEnd = (event) => {
    const date = new Date(event.target.value); // Parse the input date
    date.setHours(23, 59, 59, 0); // Set time to 23:59:59
    const formattedDate = formatDate(date); // Format the date
    setDateEnd(formattedDate);
    console.log(formattedDate)

  };
  const onGetDocumentsByFilter = () => {
    setListTransaction([]);
    startLoading();
    BanqueService.getListPayementsForExtrait(
      getCurrentUserId(),
      sessionStorage.getItem("idBankAccount"),
     dateBegin !== "any" ? dateBegin : "any",
      dateEnd !== "any" ? dateEnd : "any"
    )
      .then((response) => {
        console.log(response);
        setData(response.data);
      })
      .catch(() => {
        console.log("error");
      })
      .finally(() => {
        stopLoading();
      });
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h4 class="card-title">Le Compte </h4>
                  <br />
                  <br />
                  {banqueAccountInfo && (
                    <>
                      <p> RIB :{banqueAccountInfo.rib}</p>
                      <p>Compte :{banqueAccountInfo.name}</p>
                      <p>Adresse :{banqueAccountInfo.agenceLocalisation}</p>
                      <p>Solde actuel :{banqueAccountInfo.solde}</p>

                    </>
                  )}
                  {/* {se && <p> Sortie :{ss}</p>}
                  {se && <p> Entrée :{se}</p>}
                  {tt && <p> Total :{tt}</p>} */}
                </div>
              </div>

              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="date"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>
                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          // value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="date"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer d-flex">
                                    <div className="col-sm-3  text-center">
</div>
                  
                  <div className="col-sm-6  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={onGetDocumentsByFilter}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
                          {data && typeof data === 'object' && Object.keys(data).length > 0 && <ExtraitTable data={data} banqueAccountInfo={banqueAccountInfo} />}

              {/* {entree &&
                <div className="card-footer">
                  <div className=" my-2"><strong> Les Entrées</strong></div>
                  <div className="d-flex justify-content-between flex-wrap">
                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>

                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Espéce</span>
                        <span className="info-box-number">{entree?.eEspece}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>

                      </div>
                    </div>

                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">TPE</span>
                        <span className="info-box-number">{entree?.eEnligne}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Chéque</span>
                        <span className="info-box-number">{entree?.eChequeTraites}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Virement</span>
                        <span className="info-box-number">{entree?.eVirement}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-success col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Carte cadeau</span>
                        <span className="info-box-number">{entree?.eCarteCadeau}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>} */}
              {/* {sortie &&
                <div className="card-footer">
                  <div className=" my-2"><strong>Les Sorties</strong></div>
                  <div className="d-flex justify-content-between flex-wrap">
                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>

                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Espéce</span>
                        <span className="info-box-number">{sortie?.sEspece}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>

                      </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">TPE</span>
                        <span className="info-box-number">{sortie?.sEnligne}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Chéque</span>
                        <span className="info-box-number">{sortie?.sChequeTraites}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Virement</span>
                        <span className="info-box-number">{sortie?.sVirement}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>

                    <div className="info-box bg-danger col-md-2 col-sm-5 col-12 m-2">
                      <span className="info-box-icon">
                        <i class="fas fa-money-bill"></i>
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">Carte cadeau</span>
                        <span className="info-box-number">{sortie?.sCarteCadeau}</span>
                        <div className="progress">
                          <div className="progress-bar" style={{ width: "70%" }}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>} */}

              {/* {listTransaction.length > 0 && (
                <DataTableTransactions listTransaction={listTransaction} />
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}
export default withLoader(ExtraitBankAccount)